import { useSite } from "@/lib/site";
import { PageHeader, Reveal } from "@/components/site/common";
import { Approach, CtaBand } from "@/components/site/Sections";
import { ReviewSpotlight } from "@/components/site/Reviews";

const VALUES = [
  ["Clarity", "Plain-language advice, written scopes and prices agreed before work begins."],
  ["Craft", "Campaigns and websites built with care, tested and refined — not rushed out."],
  ["Accountability", "We measure what matters and report on it honestly, good news or not."],
  ["Momentum", "Small, steady improvements every month that compound into real growth."],
];

export default function About() {
  const { content } = useSite();
  return (
    <>
      <PageHeader overline="About the studio" title={content.about_title} testid="about-header" />
      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-24 grid lg:grid-cols-12 gap-12 items-start">
        <Reveal className="lg:col-span-6">
          <div className="rounded-[2rem] overflow-hidden aspect-[4/5] bg-slate-100 shadow-xl">
            {content.about_image && <img src={content.about_image} alt="The Click & Grow team" className="w-full h-full object-cover" data-testid="about-image" />}
          </div>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-6 lg:pt-10 space-y-6" >
          {(content.about_body || "").split("\n\n").map((para, i) => (
            <p key={para} className={i === 0 ? "font-display text-2xl font-semibold leading-snug text-slate-900" : "text-lg text-slate-600 leading-relaxed"} data-testid={`about-body-${i}`}>{para}</p>
          ))}
          <div className="grid grid-cols-3 gap-4 pt-6 border-t">
            {[["4", "Core services"], ["1", "Connected team"], ["USD", "Clear pricing"]].map(([n, l]) => (
              <div key={l}><p className="font-display text-3xl font-extrabold text-blue-600">{n}</p><p className="text-sm text-slate-500">{l}</p></div>
            ))}
          </div>
        </Reveal>
      </section>
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-20 sm:pb-28">
        <p className="overline mb-4">What we value</p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
          {VALUES.map(([t, d], i) => (
            <Reveal key={t} delay={i * 0.06} className="rounded-3xl bg-white border border-slate-200 p-7 hover:border-blue-500 transition-colors">
              <p className="font-mono text-xs text-blue-600">0{i + 1}</p>
              <p className="mt-8 font-display text-xl font-bold" data-testid={`about-value-${t.toLowerCase()}`}>{t}</p>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{d}</p>
            </Reveal>
          ))}
        </div>
      </section>
      <ReviewSpotlight />
      <Approach />
      <CtaBand />
    </>
  );
}
